import React from 'react'
import block from 'bem-cn'
import { motion } from 'framer-motion'

import { ReactComponent as GoBackSvg } from 'shared/img/goBack.svg'

import './BackButton.scss'

const b = block('slot-back-button')

interface IBetslipButton {
  callback: () => void
}

export const BackButton: React.FC<IBetslipButton> = ({ callback }) => {
  const onClickHandler = () => callback()

  return (
    <motion.div className={b()} onClick={onClickHandler}>
      <GoBackSvg className={b('goBack')} />
    </motion.div>
  )
}

export default BackButton
